/* global imagesLoaded */
export default class IsotopeListing {
	constructor(gallery) {
		if ( ! gallery ) return;

		this.gallery = gallery
		this.init();
	}

	init() {
		imagesLoaded(this.gallery).on('progress', () => {
			this.listingWrapperIsotope = new Isotope(
				document.querySelector( '.isotope-listing' ),
				{
					itemSelector: 'article',
				}
			)
		})
	}



}
